export default __webpack_public_path__ + "static/media/ichigoyogurtt.f671651b.jpeg";